module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-right-blue-3952d9b57196734e31bf750f3bf470de.svg";